/* eslint-disable class-methods-use-this */
import { DashboardSortBy } from "../../../__generated__/api";
import TicketItem from "../ticket-item";
import { SORT_REGISTRY, SortBy } from "./base";

export default class SortByLastModified extends SortBy {
    public static shouldCreate(sortBy: DashboardSortBy): boolean {
        return sortBy === DashboardSortBy.LastResponseDateAscending || sortBy === DashboardSortBy.LastResponseDateDescending;
    }

    public sort(chats: TicketItem[]): TicketItem[] {
        const multiplier = this.sortBy === DashboardSortBy.LastResponseDateAscending ? 1 : -1;
        return chats.sortBy(chat => multiplier * (chat.lastUserMessageDate ? new Date(chat.lastUserMessageDate).getTime() : 0));
    }
}

SORT_REGISTRY.register(SortByLastModified);
